import { Body, Controller, Post, UploadedFile, UploadedFiles, UseInterceptors } from "@nestjs/common";
import { FileInterceptor, FilesInterceptor } from "@nestjs/platform-express";
import { ApiBody, ApiConsumes, ApiTags } from "@nestjs/swagger";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { CKMeasurementLabelHangtagReq, CommonResponseModel } from "@project-management-system/shared-models";
import * as fs from 'fs';
import { diskStorage } from "multer";
import { extname, join } from "path";
import { FileUploadMainDto } from "./dto/file-upload-req.dto";
import { ImageReqDto } from "./dto/image-req.dto";
import { ImageUploadDTO } from "./dto/images-dto";
import { ParameterDto } from "./dto/parameter-dto";
import { StylesDto } from "./dto/styles-dto";
import { WfxService } from "./wfx.service";
@ApiTags("/wfx")
@Controller("/wfx")
export class WfxController {
    constructor(
        private readonly Service: WfxService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }
    @Post('/fileUpload')
    @UseInterceptors(FilesInterceptor('file', 10, {
        storage: diskStorage({
            destination: (req, file, callback) => {
                const destinationPath = join(__dirname, '../../../../', `image_files`);
                try {
                    fs.mkdirSync(destinationPath, { recursive: true });
                    callback(null, destinationPath);
                } catch (error) {
                    callback(error, null);
                }
            },
            filename: (req, file, callback) => {
                const name = file.originalname.split('.')[0];
                const fileExtName = extname(file.originalname);
                const randomName = Array(4)
                    .fill(null)
                    .map(() => Math.round(Math.random() * 16).toString(16))
                    .join('');
                callback(null, `${name}-${randomName}${fileExtName}`);
            },
        }),
        fileFilter: (req, file, callback) => {
            if (!file.originalname.match(/\.(xlsx|xls|pdf|jpg|png|jpeg|doc|PDF)$/)) {
                return callback(new Error('Only xlsx, xls, pdf, jpg, png, doc, jpeg files are allowed!'), false);
            }
            callback(null, true);
        },
    }))
    async updateStylePath(@UploadedFiles() files: Express.Multer.File[], @Body() req: any): Promise<CommonResponseModel> {
        try {
            const pdfFile = files.find(file => file.mimetype === 'application/pdf');
            return await this.Service.updatePath(files, req.excelFileName, req.pdfFileName, pdfFile, req.randomId, req.dropDown);
        } catch (error) {
            return (error);
        }
    }

    @Post('/saveExcelPath')
    @UseInterceptors(FilesInterceptor('file', 10, {
        storage: diskStorage({
            destination: (req, file, callback) => {
                const destinationPath = join(__dirname, '../../../../', `image_files`)
                try {
                    fs.mkdirSync(destinationPath, { recursive: true });
                    callback(null, destinationPath);
                } catch (error) {
                    callback(error, null);
                }
            },

            filename: (req, file, callback) => {
                const name = req.body.fileName.split('.')[0];
                const fileExtName = extname(req.body.fileName);
                const randomName = Array(4)
                    .fill(null)
                    .map(() => Math.round(Math.random() * 16).toString(16))
                    .join('');
                callback(null, `${name}-${randomName}${fileExtName}`);
            },
        }),
        fileFilter: (req, file, callback) => {
            callback(null, true);
        },
    }))
    async saveExcelPath(@UploadedFiles() files: Express.Multer.File[], @Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.updatePath(files, req.fileName, req.pdfFileName, req.pdfFile, req.randomId, req.dropDown)
        } catch (error) {
            return (error);
        }
    }

    @Post('/updateUnitTwelvePath')
    @UseInterceptors(FilesInterceptor('file', 10, {
        storage: diskStorage({
            destination: (req, file, callback) => {
                const destinationPath = join(__dirname, '../../../../', `pdf_files`);
                try {
                    fs.mkdirSync(destinationPath, { recursive: true });
                    callback(null, destinationPath);
                } catch (error) {
                    callback(error, null);
                }
            },
            filename: (req, file, callback) => {
                const name = file.originalname.split('.')[0];
                const fileExtName = extname(file.originalname);
                const randomName = Array(4)
                    .fill(null)
                    .map(() => Math.round(Math.random() * 16).toString(16))
                    .join('');
                callback(null, `${name}-${randomName}${fileExtName}`);
            },
        }),
        fileFilter: (req, file, callback) => {
            if (!file.originalname.match(/\.(xlsx|xls|pdf|jpg|png|jpeg|doc|PDF)$/)) {
                return callback(new Error('Only xlsx, xls, pdf, jpg, png, doc, jpeg files are allowed!'), false);
            }
            callback(null, true);
        },
    }))
    async updateUnitTwelvePath(@UploadedFiles() files: Express.Multer.File[], @Body() req: any): Promise<CommonResponseModel> {
        try {
            const pdfFile = files.find(file => file.mimetype === 'application/pdf');
            return await this.Service.updateUnitTwelvePath(files, req.excelFileName, req.pdfFileName, pdfFile, req.randomId, req.dropDown, req.soNumber);
        } catch (error) {
            return (error);
        }
    }

    @Post('/saveUnitTweleveExcelPath')
    @UseInterceptors(FilesInterceptor('file', 10, {
        storage: diskStorage({
            destination: (req, file, callback) => {
                const destinationPath = join(__dirname, '../../../../', `pdf_files`)
                try {
                    fs.mkdirSync(destinationPath, { recursive: true });
                    callback(null, destinationPath);
                } catch (error) {
                    callback(error, null);
                }
            },

            filename: (req, file, callback) => {
                const name = req.body.fileName.split('.')[0];
                const fileExtName = extname(req.body.fileName);
                const randomName = Array(4)
                    .fill(null)
                    .map(() => Math.round(Math.random() * 16).toString(16))
                    .join('');
                callback(null, `${name}-${randomName}${fileExtName}`);
            },
        }),
        fileFilter: (req, file, callback) => {
            callback(null, true);
        },
    }))
    async saveUnitTweleveExcelPath(@UploadedFiles() files: Express.Multer.File[], @Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.updateUnitTwelvePath(files, req.fileName, req.pdfFileName, req.pdfFile, req.randomId, req.dropDown, req.soNumber)
        } catch (error) {
            return (error);
        }
    }

    @Post('/getPdfFileInfo')
    async getPdfFileInfo(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.getPdfFileInfo(req);
        } catch (err) {
            return (err);
        }
    }

    @Post('/getUnitTwelvePDFInfo')
    async getUnitTwelvePDFInfo(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.getUnitTwelvePDFInfo(req);
        } catch (err) {
            return (err);
        }
    }

    @Post('/getAllUnitTwelvePDFData')
    async getAllUnitTwelvePDFData(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.getAllUnitTwelvePDFData(req);
        } catch (err) {
            return (err);
        }
    }

    @Post('/folderImageSave')
    @UseInterceptors(FilesInterceptor('file', 200, {
        storage: diskStorage({
            destination: join(__dirname, '../../../../', `image_files`),
            filename: (req, file, callback) => {
                console.log(file.originalname);
                const name = file.originalname;
                callback(null, `${name}`);
            },
        }),
        fileFilter: (req, file, callback) => {
            if (!file.originalname.match(/.(jpg|png|jpeg|JPG|PNG|JPEG)/)) {
                return callback(new Error('Only png,jpg,jpeg,JPG,PNG,JPEG files are allowed!'), false);
            }
            callback(null, true);
        },
    }))
    async folderImageSave(@UploadedFiles() filesData: File[], @Body() uploadData: any, buyer: any, parameter: any): Promise<any> {
        try {
            return await this.Service.folderImageSave(filesData, uploadData.createdUser, uploadData.id, uploadData.buyer, uploadData.materialCode,uploadData.modifiedOriginalName)
        } catch (error) {
            return error
        }
    }


    @Post('/deleteFolderImagesImageUploadStatus')
    async deleteFolderImagesImageUploadStatus(@Body() req:any): Promise<CommonResponseModel> {
        try {
            return await this.Service.deleteFolderImagesImageUploadStatus(req)
        }
        catch (err) {
            return err
        }
    }
    
    @Post('/getAllFolderImages')
    async getAllFolderImages(): Promise<CommonResponseModel> {
        try {
            return await this.Service.getAllFolderImages()
        }
        catch (err) {
            return err
        }
    }

    @ApiBody({ type: ImageReqDto })
    @Post('/updateFolderImagesStatus')
    async updateFolderImagesStatus(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.updateFolderImagesStatus(req);
        } catch (err) {
            return err;
        }
    }

    @Post('/updateFolderImagesDeleteStatus')
    @ApiBody({ type: ImageUploadDTO })
    async updateFolderImagesDeleteStatus(@Body() req: any): Promise<CommonResponseModel> {
        return await this.Service.updateFolderImagesDeleteStatus(req)
    }

    @Post('/fileSave')
    @UseInterceptors(FilesInterceptor('file', 200, {
        storage: diskStorage({
            destination: join(__dirname, '../../../../', `image_files`),
            filename: (req, file, callback) => {
                console.log(file.originalname);
                const name = file.originalname;
                callback(null, `${name}`);
            },
        }),
        fileFilter: (req, file, callback) => {
            if (!file.originalname.match(/.(jpg|png|jpeg|JPG|PNG|JPEG)/)) {
                return callback(new Error('Only png,jpg,jpeg,JPG,PNG,JPEG files are allowed!'), false);
            }
            callback(null, true);
        },
    }))
    async fileSave(@UploadedFiles() filesData: File[], @Body() uploadData: any, buyer: any, parameter: any): Promise<any> {
        try {
            return await this.Service.fileSave(filesData, uploadData.createdUser, uploadData.id, uploadData.buyer, uploadData.materialCode)
        } catch (error) {
            return error
        }
    }

    @Post('/updateImageUploadStatus')
    @ApiBody({ type: ImageUploadDTO })
    async updateImageUploadStatus(@Body() req: any): Promise<CommonResponseModel> {
        return await this.Service.updateImageUploadStatus(req)
    }

    @Post('/getAllCarharttImages')
    async getAllCarharttImages(): Promise<CommonResponseModel> {
        try {
            return await this.Service.getAllCarharttImages()
        }
        catch (err) {
            return err
        }
    }

    @Post('/saveCarharttData')
    async saveCarharttData(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.saveCarharttData(req);
        } catch (err) {
            return (err);
        }
    }

    @ApiBody({ type: StylesDto })
    @Post('/createCarharttData')
    async createCarharttData(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.createCarharttData(req);
        } catch (err) {
            return (err);
        }
    }

    @Post('/updateTrimCardView')
    async updateTrimCardView(@Body() req: any): Promise<CommonResponseModel> {
        return await this.Service.updateTrimCardView(req)
    }

    @Post('/getAllCarharttMeasurementData')
    async getAllCarharttMeasurementData(): Promise<CommonResponseModel> {
        try {
            return await this.Service.getAllCarharttMeasurementData()
        }
        catch (err) {
            return err
        }
    }

    @Post('/getAllCarharttMeasurementDataPDMFolders')
    async getAllCarharttMeasurementDataPDMFolders(): Promise<CommonResponseModel> {
        try {
            return await this.Service.getAllCarharttMeasurementDataPDMFolders()
        }
        catch (err) {
            return err
        }
    }

    @Post('/updateThreadsShadeCK')
    async updateThreadsShadeCK(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.updateThreadsShadeCK(req)
        }
        catch (err) {
            return err
        }
    }

    @Post('/updateLabelHangtagsDescriptionCK')
    async updateLabelHangtagsDescriptionCK(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.updateLabelHangtagsDescriptionCK(req)
        }
        catch (err) {
            return err
        }
    }

    @Post('/deleteBlockCK')
    async deleteBlockCK(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.deleteBlockCK(req)
        }
        catch (err) {
            return err
        }
    }

    @Post('/getStylesFileName')
    async getStylesFileName(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.getStylesFileName(req)
        }
        catch (err) {
            return err
        }
    }

    @Post('/getImageNames')
    async getImageNames(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.getImageNames(req);
        } catch (err) {
            return (err);
        }
    }

    @Post('/saveBuyer')
    async saveBuyer(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.saveBuyer(req, false);
        } catch (err) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, err);
        }
    }

    @Post('/buyerFileSave')
    @ApiConsumes('multipart/form-data')
    @UseInterceptors(FileInterceptor('file', {
        limits: { files: 1 },
        storage: diskStorage({
            destination: join(__dirname, '../../../../', `image_files`),
            filename: (req, file, callback) => {
                console.log(file.originalname);
                const name = file.originalname;
                callback(null, `${name}`);
            },
        }),
        fileFilter: (req, file, callback) => {
            if (!file.originalname.match(/\.(jpg|png|jpeg|JPG|PNG|JPEG)$/)) {
                return callback(new Error('Only jpg,png,jpeg files are allowed!'), false);
            }
            callback(null, true);
        },
    }))
    async buyerFileSave(@UploadedFile() file, @Body() uploadData: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.buyerFileSave(file.path, file.filename, uploadData.id, file.originalname);
        } catch (error) {
        }
    }

    // @Post('/updateTrimCardFileSave')
    // @ApiConsumes('multipart/form-data')
    // @UseInterceptors(FileInterceptor('file', {
    //     limits: { files: 1 },
    //     storage: diskStorage({
    //         destination: join(__dirname, '../../../../', `pdf_files`),
    //         filename: (req, file, callback) => {
    //             console.log(file.originalname);
    //             const name = file.originalname;
    //             callback(null, `${name}`);
    //         },
    //     }),
    //     fileFilter: (req, file, callback) => {
    //         if (!file.originalname.match(/\.(pdf|.PDF)$/)) {
    //             return callback(new Error('Only pdf'), false);
    //         }
    //         callback(null, true);
    //     },
    // }))
    // async updateTrimCardFileSave(@UploadedFile() file, @Body() uploadData: any): Promise<CommonResponseModel> {
    //     try {
    //         return await this.Service.updateTrimCardFileSave(file.path, file.filename, uploadData.id, file.originalname);
    //     } catch (error) {
    //     }
    // }

    @Post('/updateTrimCardFileSave')
    @ApiConsumes('multipart/form-data')
    @UseInterceptors(FilesInterceptor('file', 10, {
        storage: diskStorage({
            destination: join(__dirname, '../../../../', `pdf_files`),
            filename: (req, file, callback) => {
                const name = file.originalname;
                callback(null, `${name}`);
            },
        }),
        fileFilter: (req, file, callback) => {
            if (!file.originalname.match(/\.(pdf|PDF)$/)) {
                return callback(new Error('Only PDF files are allowed'), false);
            }
            callback(null, true);
        },
    }))
    async updateTrimCardFileSave(@UploadedFiles() files: Array<Express.Multer.File>, @Body() uploadData: any, base64?: any): Promise<CommonResponseModel> {
        try {
            const filePaths = files.map(file => file.path).join(', ');
            const fileNames = files.map(file => file.filename).join(', ');
            const originalNames = files.map(file => file.originalname).join(', ');

            return await this.Service.updateTrimCardFileSave(filePaths, fileNames, uploadData.id, originalNames, uploadData.base64);
        } catch (error) {
            console.error('Error saving files', error);
            throw new Error('File upload failed');
        }
    }

    @Post('/updateBuyer')
    async updateBuyer(@Body() req: any): Promise<CommonResponseModel> {
        return await this.Service.saveBuyer(req, true)
    }


    @Post('/updateStatusStyle')
    async updateStatusStyle(@Body() req: any): Promise<CommonResponseModel> {
        return await this.Service.updateStatusStyle(req)
    }

    @Post('/getAllBuyers')
    async getAllBuyers(req?: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.getAllBuyers(req);
        } catch (err) {
            return (err);
        }
    }

    @ApiBody({ type: ParameterDto })
    @Post('/saveParameter')
    async saveParameter(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.saveParameter(req);
        } catch (err) {
            return (err);
        }
    }

    @Post('/getAllParameters')
    async getAllParameters(): Promise<CommonResponseModel> {
        try {
            return await this.Service.getAllParameters();
        } catch (err) {
            return (err);
        }
    }


    @ApiBody({ type: ImageReqDto })
    @Post('/updateImageUpload')
    async updateImageUpload(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.updateImageUpload(req);
        } catch (err) {
            return err;
        }
    }

    @Post('/TrimCardImageSave')
    @UseInterceptors(FilesInterceptor('file', 10, {
        storage: diskStorage({
            destination: join(__dirname, '../../../../', `image_files`),
            filename: (req, file, callback) => {
                console.log(file.originalname);
                const name = file.originalname;
                callback(null, `${name}`);
            },
        }),
        fileFilter: (req, file, callback) => {
            if (!file.originalname.match(/\.(jpg|png|jpeg|JPG|PNG|JPEG)$/)) {
                return callback(new Error('Only png,jpg,jpeg files are allowed!'), false);
            }
            callback(null, true);
        },
    }))
    async TrimCardImageSave(@UploadedFiles() filesData: File[], @Body() uploadData: any, buyer: any, parameter: any): Promise<any> {
        try {
            return await this.Service.TrimCardImageSave(filesData, uploadData.createdUser, uploadData.id, uploadData.buyer, uploadData.parameter)
        } catch (error) {
            return error
        }
    }

    @Post('/saveUnitTwelveExcelData')
    async saveUnitTwelveExcelData(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.saveUnitTwelveExcelData(req);
        } catch (err) {
            return (err);
        }
    }

    @Post('/getAllPdfsData')
    async getAllPdfsData(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.getAllPdfsData();
        } catch (err) {
            return (err);
        }
    }



    @Post('/saveTechPackData')
    @UseInterceptors(FilesInterceptor('extractedFile', 10, {
        storage: diskStorage({
            destination: join(__dirname, '../../../../', `image_files`),
            filename: (req, file, callback) => {
                console.log(file.originalname);
                const name = file.originalname;
                callback(null, `${name}`);
            },
        }),
        // fileFilter: (req, file, callback) => {
        //     // if (!file.originalname.match(/\.(jpg|png|jpeg|JPG|PNG|JPEG)$/)) {
        //     //     return callback(new Error('Only png,jpg,jpeg files are allowed!'), false);
        //     // }
        //     callback(null, true);
        // },
    }))
    async saveTechPackData(@UploadedFiles() filesData: any[], @Body() req: any): Promise<CommonResponseModel> {
        try {
            req = JSON.parse(req.techPackData)
            return await this.Service.saveTechPackData(filesData, req);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    };


    @Post('getTechPackGridData')
    async getTechPackGridData(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.getTechPackGridData(req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('getVersionsGridData')
    async getVersionsGridData(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.getVersionsGridData(req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('getAllVersions')
    async getAllVersions(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.getAllVersions(req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('getAllTechPackData')
    async getAllTechPackData(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.getAllTechPackData(req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('deleteArticleApparelMaster')
    async deleteArticleApparelMaster(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.deleteArticleApparelMaster(req.apparelId, req.deleteVersion)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('getAllTechPckAndVersionsData')
    async getAllTechPckAndVersionsData(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.getAllTechPckAndVersionsData(req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('approveOriginalsRecords')
    async approveOriginalsRecords(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.approveOriginalsRecords(req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/deleteMeasurementDataCard')
    async deleteMeasurementDataCard(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.deleteMeasurementDataCard(req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @Post('/deleteBuyerMaster')
    async deleteBuyerMaster(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.deleteBuyerMaster(req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }

    @ApiConsumes('multipart/form-data')
    @ApiBody({ type: FileUploadMainDto })
    @Post('/multipleFileUploads')
    @UseInterceptors(FilesInterceptor('files', 10, {
        storage: diskStorage({
            destination: (req, file, callback) => {
                const destinationPath = join(__dirname, '../../../../', `pdf_files`);
                try {
                    fs.mkdirSync(destinationPath, { recursive: true });
                    callback(null, destinationPath);
                } catch (error) {
                    callback(error, null);
                }
            },
            filename: (req, file, callback) => {
                const name = file.originalname.split('.')[0];
                const fileExtName = extname(file.originalname);
                const randomName = Array(4)
                    .fill(null)
                    .map(() => Math.round(Math.random() * 16).toString(16))
                    .join('');
                callback(null, `${name}-${randomName}${fileExtName}`);
            },
        }),
        fileFilter: (req, file, callback) => {
            if (!file.originalname.match(/\.(PDF|pdf)$/)) {
                return callback(new Error('Only pdf files are allowed!'), false);
            }
            callback(null, true);
        },
    }))
    async multipleFileUploads(@UploadedFiles() files: Express.Multer.File[], extractedData?: any[]): Promise<CommonResponseModel> {
        // console.log(files, "controller files");
        try {
            return await this.Service.multipleFileUploads(files);
        } catch (err) {
            console.error('Error during file upload:', err);
            throw new Error('File upload failed');
        }
    }


    @ApiConsumes('multipart/form-data')
    @ApiBody({ type: FileUploadMainDto })
    @Post('/multipleFileUploadsCK')
    @UseInterceptors(FilesInterceptor('files', 10, {
        storage: diskStorage({
            destination: (req, file, callback) => {
                const destinationPath = join(__dirname, '../../../../', `pdf_files`);
                try {
                    fs.mkdirSync(destinationPath, { recursive: true });
                    callback(null, destinationPath);
                } catch (error) {
                    callback(error, null);
                }
            },
            filename: (req, file, callback) => {
                const name = file.originalname.split('.')[0];
                const fileExtName = extname(file.originalname);
                const randomName = Array(4)
                    .fill(null)
                    .map(() => Math.round(Math.random() * 16).toString(16))
                    .join('');
                callback(null, `${name}-${randomName}${fileExtName}`);
            },
        }),
        fileFilter: (req, file, callback) => {
            if (!file.originalname.match(/\.(PDF|pdf)$/)) {
                return callback(new Error('Only pdf files are allowed!'), false);
            }
            callback(null, true);
        },
    }))
    async multipleFileUploadsCK(@UploadedFiles() files: Express.Multer.File[], extractedData?: any[]): Promise<CommonResponseModel> {
        // console.log(files, "controller files");
        try {
            return await this.Service.multipleFileUploadsCK(files);
        } catch (err) {
            console.error('Error during file upload:', err);
            throw new Error('File upload failed');
        }
    }


    @Post('/createCKDigitalTrimCard')
    async createCKDigitalTrimCard(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.createCKDigitalTrimCard(req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }


    @Post('/updateColumbiaCardUNDO')
    async updateColumbiaCardUNDO(@Body() req: any): Promise<CommonResponseModel> {
        try {
            return await this.Service.updateColumbiaCardUNDO(req)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponseModel, error);
        }
    }


}
